import { useEffect } from "react";
// eslint-disable-next-line no-unused-vars
import CustomWidget from "./CustomWidget";

import "./App.css";

function App() {
    useEffect(() => {
        let count = 0;

        const loop = setInterval(() => {
            let buttonOpenChat = document.getElementsByClassName("rw-launcher");
            let chatOpen = document.getElementsByClassName(
                "rw-conversation-container"
            );

            if (buttonOpenChat.length > 0 && chatOpen.length === 0) {
                buttonOpenChat[0].click();
                clearInterval(loop);
            }

            if (count === 5) clearInterval(loop);

            count++;
        }, 500);
    }, []);

    return (
        <div className="App">
            <CustomWidget />
        </div>
    );
}

export default App;
